'use client';

import { EntitlementsProvider } from '@contexts/EntitlementsContext';
import { AtomicContext } from '@contexts/coveo/AtomicContext';
import { AtomicLayoutSection } from '@coveo/atomic-react';
import { Tag } from '@lib/types/common/Tag';
import { useContext } from 'react';
import { HeadlessProductCardWrapper } from './HeadlessProductCardWrapper';
import { useResults } from './hooks/useResults';

type AtomicResultsSectionV2Props = {
  productTags?: Tag[];
  context: AtomicContext;
};

/**
 * V2 Results Section with custom responsive grid based on Figma specs:
 * - <392px: 1 column
 * - 392px-579px: 2 columns (card min-width 172px)
 * - 580px-1023px: 3 columns
 * - 1024px+: 4 columns (flexible card width, determined by grid and available space)
 *
 * Note: These are custom breakpoints from Figma, not standard Tailwind breakpoints
 */
export const AtomicResultsSectionV2 = ({
  productTags,
  context,
}: AtomicResultsSectionV2Props) => {
  const { searchEngine } = useContext(context);
  const { results: resultState } = useResults(searchEngine);

  return (
    <EntitlementsProvider>
      <AtomicLayoutSection data-test="search-result-section" section="results">
        {resultState?.results && resultState.results.length > 0 && (
          <ul
            data-test="search-results-list"
            className="grid grid-cols-1 justify-evenly gap-4 min-[392px]:grid-cols-2 min-[580px]:grid-cols-3 lg:grid-cols-4"
          >
            {resultState?.results.map((result) => (
              <li key={result.raw.ec_product_id as string}>
                <HeadlessProductCardWrapper
                  context={context}
                  result={result}
                  allProductTags={productTags}
                />
              </li>
            ))}
          </ul>
        )}
      </AtomicLayoutSection>
    </EntitlementsProvider>
  );
};
